import React, { useState, useContext } from "react";
import { callApi } from "bodycodi/cmap/app/js/common";
import Drawer from "@material-ui/core/Drawer";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import logo from "bodycodi/cmap/app/img/bodycodi-logo.png";
import TernsService from "bodycodi/cmap/app/components/cmap1010/ternsService";

const TermsConfirm = () => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const [allAgree, setAllAgree] = useState(false);
  const [agreeMarketingYn, setAgreeMarketingYn] = useState(false);

  const handleSubmit = () => {
    if (allAgree) {
      callApi(
        "/service/terms",
        {
          termAgree: "Y",
          privacyAgree: "Y",
          marketingAgree: agreeMarketingYn ? "Y" : "N",
        },
        "POST"
      ).then((res) => {
        dispatch({
          type: "POP_UP_OPEN",
          id: "CONFIRM_TERMS_POP",
          open: { confirmTermsPop: false },
        });
      });
    }
  };
  return (
    <Drawer anchor="bottom" open={state.confirmTermsPop} className="picker-pop auto">
      <div className="picker-body choose-schedule-type-pop">
        <div className="tern-service-header confirm">
          <img src={logo} />
          <div className="black">
            강사앱의 새로운 약관에
            <br />
            동의해주세요
          </div>
          <div className="desc">새로워진 강사앱은 약관동의 후 이용하실 수 있어요!</div>
        </div>
        <TernsService setAgree={setAllAgree} setAgreeMarketingYn={setAgreeMarketingYn} />
        <div
          className={`cmap1010-btn${allAgree ? " active" : ""}`}
          onClick={allAgree ? handleSubmit : undefined}
        >
          동의하기
        </div>
      </div>
    </Drawer>
  );
};

export default TermsConfirm;
